<div class="label" [class]="config.class">
    <span class="stc-text-primary-200 stc-font-medium stc-text-mmmd label-title">
      {{ config.isTranslated ? (config.label! | translate) : config.label }}
    </span>
    <span class="stc-text-grey-700 stc-font-regular stc-text-bas label-value">
      <span *ngIf="!viewItemValue">{{ config.value }}</span>
      <ng-template *ngTemplateOutlet="viewItemValue"></ng-template>
    </span>
  </div>
  